$(document).ready(function () {
    let status = '';
    let btn_update_status = ''
    $('#table-reminder').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-reminder",
        "columns": [
            {data: 'id'},
            {data: 'remind'},
            {data: 'reminder_day'},
        ],
        "columnDefs": [
            {
                "targets": 3,
                "render": function (data, type, row, meta) {
                    status = get_global_code_status(row.status_code)
                    if (row.status_code != "finalized") {
                        btn_update_status = '<button data-toggle="tooltip" data-placement="top" title="' + status.title + '" ' +
                            'class="btn btn-' + status.color_clas + ' update-status-remind btn-sm m-1"' + 'data-slug ="' + row.slug + '">' +
                            '<i class="' + status.icon + '"></i>' +
                            '</button>'
                    }
                    return '<button data-toggle="tooltip" data-placement="top" title="Editar recordatorio" ' +
                        'class="btn btn-primary edit-reminder btn-sm"' + 'data-id ="' + row.id + '">' +
                        '<i class="far fa-edit"></i>' +
                        '</button>' +
                        btn_update_status
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });

    $("#add-reminder").on('click', function (e) {
        e.preventDefault();
        $("#form-reminder")[0].reset()
        $('.item-frequency').val('').trigger("chosen:updated")
        $(".item-slug").val()
        $(".modal-title").text('Nuevo recordatorio')
        $("#modal-reminder").modal('show')
    })

    $("#table-reminder tbody").on('click', '.edit-reminder', function () {
        let list_reminders = $("#table-reminder").DataTable();
        let rowData = list_reminders.row($(this).parents('tr')).data();
        $.each(rowData, function (index, value) {
            if (index === "frequency") {
                $('.item-frequency').val(value).trigger("chosen:updated");
            }
            $(".item-" + index).val(value)
        })
        $(".modal-title").text('Editar recordatorio')
        $("#modal-reminder").modal('show');
    })

    $("#table-reminder tbody").on('click', '.update-status-remind', function (e) {
        let slug = $(this).data('slug')
        let data = new FormData()
        data.append('slug', slug)
        $.ajax({
            url: '/update-status-remind',
            type: 'POST',
            data: data,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                alertSuccess(data.msg)
                $("#table-reminder").DataTable().ajax.reload();
            }
        });
    })

    $("#form-reminder").on('submit', function (e) {
        e.preventDefault()
        clearSpan()
        sendData($("#form-reminder").serializeArray(), '/send-data-reminder')
    })

    $("#finalize-reminder").on('click', function (e) {
        e.preventDefault()

        let slug = $("#slug-remind").val()
        let data = new FormData()
        data.append('slug', slug)
        Swal.fire({
            title: '¿ Estas seguro ?',
            text: "El recordatorio sera finalizado",
            icon: 'warning',
            showCancelButton: true,
            cancelButtonText: "Cancelar",
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Si, finalizar!'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: '/finalize-remind',
                    type: 'POST',
                    data: data,
                    processData: false,
                    contentType: false,
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    },
                    success: function (data) {
                        Swal.fire('Finalizado', 'El recordatorio fue finalizado.', 'success')
                            .then(() => {
                                window.location = window.location.origin;
                            });
                    }
                });
            }
        })

    })

    function sendData(data, route) {
        $.ajax({
            url: route,
            type: 'POST',
            data: data,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            success: function (data) {
                alertSuccess(data.msg)
                $("#modal-reminder").modal('hide')
                $("#table-reminder").DataTable().ajax.reload()
            }, error: function (errors, xhr, status,) {
                var indices = errors.responseJSON.errors;
                $.each(indices, function (index, value) {
                    $(".item-" + index).html(value)
                });
            }
        });
    }

    function clearSpan() {
        $('item-remind').html()
        $('item-reminder_day').html()
        $('item-days_before_the_reminder').html()
        $('item-emails').html()
        $('item-frequency').html()
        $('item-comments').html()
    }
})
